import { useEffect, useState } from 'react';

// ─── VerifyEmailPage ──────────────────────────────────────────────────────────
// Shown at /verify?token=xxx — calls the backend to verify the token, then
// stores the session and redirects to the app home.
export default function VerifyEmailPage() {
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      setErrorMessage('No verification token found in this link.');
      setStatus('error');
      return;
    }

    fetch(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then((r) => r.json())
      .then((data) => {
        if (!data.success) {
          setErrorMessage(data.error?.message || 'Verification failed.');
          setStatus('error');
          return;
        }
        // Store session then redirect — App.jsx will pick up from sessionStorage
        sessionStorage.setItem('fliplist_token', data.data.token);
        sessionStorage.setItem('fliplist_user', JSON.stringify(data.data.user));
        setStatus('success');
        setTimeout(() => { window.location.href = '/'; }, 1500);
      })
      .catch(() => {
        setErrorMessage('Something went wrong. Please try again.');
        setStatus('error');
      });
  }, []);

  return (
    <div style={{
      minHeight: '100dvh',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: 'var(--color-bg, #f8faf6)',
      padding: '24px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    }}>
      <div style={{
        background: 'var(--color-bg-card, #ffffff)',
        borderRadius: '16px',
        padding: '40px 32px',
        maxWidth: '400px', width: '100%',
        textAlign: 'center',
        boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
        border: '0.5px solid var(--color-border, #e8ede6)',
      }}>
        <img
          src="/media/logo-mascot.png"
          alt=""
          style={{ width: 64, height: 64, borderRadius: 14, marginBottom: 20, objectFit: 'cover' }}
        />

        {status === 'verifying' && (
          <>
            <div style={{
              width: 28, height: 28, margin: '0 auto 20px',
              border: '2px solid #e0e8db',
              borderTopColor: '#4a7c59',
              borderRadius: '50%',
              animation: 'spin 0.7s linear infinite',
            }} />
            <h2 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 500, color: 'var(--color-text-heading, #1a1a1a)' }}>
              Verifying your email…
            </h2>
            <p style={{ margin: 0, fontSize: 13, color: 'var(--color-text-secondary, #666)' }}>
              Just a moment.
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: 40, marginBottom: 16 }}>✅</div>
            <h2 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 500, color: 'var(--color-text-heading, #1a1a1a)' }}>
              Email verified!
            </h2>
            <p style={{ margin: 0, fontSize: 13, color: 'var(--color-text-secondary, #666)' }}>
              Taking you to the app…
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: 40, marginBottom: 16 }}>⚠️</div>
            <h2 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 500, color: 'var(--color-text-heading, #1a1a1a)' }}>
              Verification failed
            </h2>
            <p style={{ margin: '0 0 24px', fontSize: 13, color: 'var(--color-text-secondary, #666)', lineHeight: 1.6 }}>
              {errorMessage}
            </p>
            <a
              href="/"
              style={{
                display: 'inline-block',
                background: '#4a7c59', color: '#eaf3de',
                textDecoration: 'none', padding: '11px 24px',
                borderRadius: 8, fontSize: 14, fontWeight: 500,
              }}
            >
              Back to sign in
            </a>
          </>
        )}
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
